import { createBrowserRouter } from "react-router-dom";
import AuthLayout from "./layouts/AuthLayout";
import Login from "./pages/login/Login.tsx";
import Register from "./pages/register/Register.tsx";
import Home from "./pages/home/Home.tsx";
import Upload from "./pages/upload/Upload.tsx";
import ProtectedRoute from "./layouts/ProtectedRoutes";
import UserDetails from "./pages/userDetails/UserDetails.tsx";
import CategoryAdmin from "./pages/categories/CategoryAdmin.tsx";
import FeedbackPage from './pages/feedback/FeedbackPage';

export const Router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <div>About</div>,
  },
  {
    path: "/login",
    element: <ProtectedRoute element={Login} />,
  },
  {
    path: "/register",
    element: <ProtectedRoute element={Register} />,
  },
  {
    element: <AuthLayout />,
    children: [
{
        path: "upload",
        element: <Upload />,
      },
      {
        path: "userDetails",
        element: <UserDetails />,
      },
      {
        path: "categories",
        element: <CategoryAdmin />,
      },
      {
        path: "feedback",
        element: <FeedbackPage />,
      },
    ],
  },
]);

export default Router;
